import type { FC } from 'react';
import { Inline } from '@george-labs.com/design-system';

import styles from './TextSymbol.module.scss';

interface Props {
    label: string;
    value?: string | null;
    ['data-cy']?: string;
}

export const TextSymbol: FC<Props> = ({ 'data-cy': dataCy, label, value }) => {
    if (!value) {
        return null;
    }
    return (
        <span data-cy={dataCy} className={styles.symbol}>
            <Inline emphasis>{label}: </Inline> {value}
        </span>
    );
};
